import React from 'react';
import { HeroBanner as HeroBannerTypes } from '../../redux/homepage/types';
import Banner, { BannerProps } from '../Generic/Banner';
import useGa from '../../hooks/useGa';
import { BannerTrackingVariations } from '../../../common/ga/homepage';
import GenericImpressionWrapper from '../Generic/GenericImpressionWrapper';

const HeroBanner: React.FC<HeroBannerTypes> = ({ ...heroBanner }) => {
    const gaTracking = useGa();
    let bannerProps: BannerProps = {
        desktopImage: heroBanner.desktopImage,
        mobileImage: heroBanner.mobileImage,
        altText: heroBanner.altText,
        trackingFn: gaTracking.homepage.getBannerTrackingFn(BannerTrackingVariations.General, heroBanner.trackingName),
    };

    if (heroBanner.targetUrl) {
        bannerProps = { ...bannerProps, targetUrl: heroBanner.targetUrl };
    }

    return (
        <GenericImpressionWrapper action={() => gaTracking.homepage.trackBannerImpression(heroBanner.trackingName)}>
            <Banner {...bannerProps} />
        </GenericImpressionWrapper>
    );
};

export default HeroBanner;
